import React from 'react';
import './Spinner.css';

const Spinner = () => <div className="Spinner">&nbsp;</div>;

export default Spinner;
